/* KK listing pages (category + search): filter panel, sort, price inputs. */
const root = document.querySelector('[data-kk-list]');
if (root && !root.dataset.ready) {
  root.dataset.ready = '1';
  const form = root.querySelector('[data-kk-list-form]');
  const panel = root.querySelector('[data-kk-filters]');
  const openBtn = root.querySelector('[data-kk-filter-open]');

  const open = () => {
    if (!panel) return;
    panel.hidden = false;
    requestAnimationFrame(() => panel.classList.add('is-open'));
    document.documentElement.classList.add('kk-lock');
    openBtn?.setAttribute('aria-expanded', 'true');
    panel.querySelector('button, input')?.focus({ preventScroll: true });
  };
  const close = () => {
    if (!panel || panel.hidden) return;
    panel.classList.remove('is-open');
    document.documentElement.classList.remove('kk-lock');
    openBtn?.setAttribute('aria-expanded', 'false');
    setTimeout(() => { panel.hidden = true; }, 320);
    openBtn?.focus({ preventScroll: true });
  };
  openBtn?.addEventListener('click', open);
  root.querySelectorAll('[data-kk-filter-close]').forEach((b) => b.addEventListener('click', close));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

  /* Sorting submits straight away. */
  root.querySelector('[data-kk-sort]')?.addEventListener('change', () => form.requestSubmit ? form.requestSubmit() : form.submit());

  /* Price inputs are typed in rupees; Shopify expects plain numbers in the URL, empty ones are dropped. */
  form?.addEventListener('submit', () => {
    form.querySelectorAll('input[type="number"]').forEach((i) => { if (i.value === '') i.disabled = true; });
  });
}
